import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../modules/station';
import { bindActionCreators } from 'redux';
import { showErrors } from '../modules/general';

// XXX memoize
const mapStateToProps = (state) => {
	let stations = [];
	if (state.lists.stationIds) {
		stations = _.map(state.lists.stationIds, (id) => state.maps.station[id]);
	}

	//- Here I want to get the other things from the state like the gasFormulas and the ethanol formulas
	//-
	const canMakeUpdates = !!_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false);
	return {
		isSearching: state.station.isSearching,
		searchFailed: state.station.searchFailed,
		stations: stations,
		gasFormulaMap: state.maps.gasFormula,
		carrierMap: state.maps.carrier,
		rackFormulaMap: state.maps.rackFormula,
		biodieselFormulaMap: state.maps.biodieselFormula,
		userMap: state.maps.user,
		authUser: state.auth.authUser,
		canMakeUpdates,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchStations: search,
			removeStation: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
